import React from "react";
import { Col, Input, Row } from "antd";
import style from "./index.module.scss";
import Form from "rc-field-form";
import { BlankType } from "service/exercise";
import FieldWithError from "components/FieldWithError";

export default function FieldFillOptions() {
    const initialValue: BlankType[] = [
        { description: "" },
        { description: "" }
    ];

    return (
        <Form.List name="blanks" initialValue={initialValue}>
            {(fields, operations, meta) => (
                <>
                    {fields.map((field, index) => (
                        <Row key={field.key} gutter={[0, 20]}>
                            <Col span={4} className={style.label}>
                                <i className={style.required}>*</i> 填空
                                {index + 1}
                            </Col>

                            <Col span={18} offset={1}>
                                <FieldWithError
                                    {...field}
                                    name={[field.name, "description"]}
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                "填空必填，请填写填空内容后再提交保存"
                                        }
                                    ]}>
                                    <Input
                                        placeholder="请填入正确答案"
                                        className={style.input}
                                        maxLength={100}
                                    />
                                </FieldWithError>
                            </Col>

                            {fields.length > 1 && (
                                <Col span={1}>
                                    <button
                                        type="button"
                                        className={style.btnDelete}
                                        onClick={() =>
                                            operations.remove(field.name)
                                        }
                                    />
                                </Col>
                            )}
                        </Row>
                    ))}

                    {fields.length < 100 && (
                        <Row gutter={[0, 20]}>
                            <Col span={5} />

                            <Col span={5}>
                                <button
                                    type="button"
                                    className={style.btnAdd}
                                    onClick={() => operations.add()}>
                                    添加填空
                                </button>
                            </Col>
                        </Row>
                    )}
                </>
            )}
        </Form.List>
    );
}
